import axiosInstanceNode from "@/api/axiosInstanceNode";

const withDays = (days) => {
  const n = Number(days);
  return Number.isFinite(n) && n > 0 ? n : 30;
};

export const getUpcomingMeetings = async ({
  days = 30,
  pastDays = 30,
  limit = 100,
} = {}) => {
  const response = await axiosInstanceNode.get("/dashboard/upcoming-meetings", {
    params: {
      days: withDays(days),
      past_days: pastDays,
      limit,
    },
    skipGlobalErrorToast: true,
  });
  return response.data?.data;
};

export const getDealsSummary = async () => {
  const response = await axiosInstanceNode.get("/dashboard/deals-summary");
  return response.data?.data;
};

// get dashboard campaign performance
export const getDashboardCampaignPerformance = async (days) => {
  const d = withDays(days);
  try {
    const response = await axiosInstanceNode.get(
      `/dashboard/campaign-aggregate?days=${d}`,
    );
    return response.data?.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to get dashboard campaign performance. Please try again.",
    );
  }
};

// get top performing campaigns
export const getTopPerformingCampaigns = async (days) => {
  const d = withDays(days);
  try {
    const response = await axiosInstanceNode.get(
      `/dashboard/campaign-list?days=${d}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to get top performing campaigns. Please try again.",
    );
  }
};

// get channel effectiveness
export const getChannelEffectiveness = async (days) => {
  const d = withDays(days);
  try {
    const response = await axiosInstanceNode.get(
      `/dashboard/channel-effectiveness?days=${d}`,
    );
    return response?.data?.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to get channel effectiveness. Please try again.",
    );
  }
};

// accounts dashboard slices (top engaged, fresh intent, dormant)
export const getAccountsDashboard = async (days) => {
  const d = withDays(days);
  try {
    const response = await axiosInstanceNode.get(`/dashboard/accounts?days=${d}`);
    return response.data?.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to get dashboard accounts. Please try again.",
    );
  }
};

export const getSimilarAccountTargets = async () => {
  // POST only because the server may start a fetch; for the user it is a read.
  const response = await axiosInstanceNode.post(
    "/dashboard/similar-account-targets",
    undefined,
    { isRead: true },
  );

  const rawAccounts = response.data?.data?.similar_accounts ?? [];
  const referenceAccounts = response.data?.data?.reference_accounts ?? [];
  const lastSyncedAt = response.data?.data?.last_synced_at ?? null;
  const unique = new Map();
  let dropped = 0;
  for (const account of rawAccounts) {
    const name = String(account?.company_name || "").trim();
    const domain = String(
      account?.company_domain || account?.["company domain"] || "",
    ).trim();
    if (!name || !domain) {
      dropped += 1;
      continue;
    }
    const key = domain.toLowerCase();
    if (!unique.has(key)) {
      unique.set(key, { ...account, company_domain: domain });
    }
  }
  console.info(
    "[SimilarTargets] client normalization",
    JSON.stringify({
      received: rawAccounts.length,
      accepted: unique.size,
      dropped
    })
  );
  return {
    similar_accounts: [...unique.values()],
    reference_accounts: referenceAccounts,
    reference_account_ids: response.data?.data?.reference_account_ids ?? [],
    last_synced_at: lastSyncedAt,
  };
};
